import dayjs from 'dayjs';

const Date = ({ value }: { value?: string }) => {
  const formattedDate = value
    ? dayjs(value).format('YYYY MMM DD')
    : '';

  return <>{formattedDate}</>;
};

export default Date;
